import React from 'react';
import PropTypes from 'prop-types';

const Information = ({ fill, size = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <title>Information</title>
    <g>
      <path
        fill={fill || '#909090'}
        fillRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </g>
  </svg>
);

Information.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.number
};

export default Information;
